import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=c79bd7ca&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c79bd7ca')) {
      api.createRecord('c79bd7ca', component.options)
    } else {
      api.reload('c79bd7ca', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=c79bd7ca&", function () {
      api.rerender('c79bd7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tqnYtcuPPfip/JS/comp/openstreetmap.vue"
export default component.exports